import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const CustomCursor = () => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isPointer, setIsPointer] = useState(false);

  useEffect(() => {
    const updateCursor = (e) => {
      setPosition({ x: e.clientX, y: e.clientY });
      const target = e.target;
      setIsPointer(window.getComputedStyle(target).cursor === 'pointer');
    };

    window.addEventListener('mousemove', updateCursor);
    return () => window.removeEventListener('mousemove', updateCursor);
  }, []);

  return (
    <>
      <CursorRing
        style={{
          transform: `translate(${position.x}px, ${position.y}px)`
        }}
        animate={{
          scale: isPointer ? 1.5 : 1,
        }}
      />
      <CursorDot
        style={{
          transform: `translate(${position.x}px, ${position.y}px)`
        }}
      />
    </>
  );
};

const CursorRing = styled(motion.div)`
  position: fixed;
  top: -15px;
  left: -15px;
  width: 30px;
  height: 30px;
  border: 2px solid #64ffda;
  border-radius: 50%;
  pointer-events: none;
  z-index: 9999;
  transition: transform 0.1s ease;
`;

const CursorDot = styled.div`
  position: fixed;
  top: -3px;
  left: -3px;
  width: 6px;
  height: 6px;
  background: #64ffda;
  border-radius: 50%;
  pointer-events: none;
  z-index: 9999;
  transition: transform 0.1s ease;
`;

export default CustomCursor;